import { toast, ToastOptions, ToastContent } from "react-toastify";

export type ToastType = "success" | "error" | "info" | "warning";

export interface ShowToastOptions {
    type?: ToastType;
    duration?: number;
}

/**
 * Hook для показу toast повідомлень
 * Заміна для @peersyst/react-components useToast
 */
export function useToast(): { showToast: (message: ToastContent, options?: ShowToastOptions) => void } {
    const showToast = (message: ToastContent, options: ShowToastOptions = {}) => {
        const { type = "info", duration = 5000 } = options;

        const toastOptions: ToastOptions = {
            autoClose: duration,
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        };

        switch (type) {
            case "success":
                toast.success(message, toastOptions);
                break;
            case "error":
                toast.error(message, toastOptions);
                break;
            case "warning":
                toast.warning(message, toastOptions);
                break;
            case "info":
            default:
                toast.info(message, toastOptions);
                break;
        }
    };

    return { showToast };
}


